import { keepPreviousData } from '@tanstack/react-query'
import { useUserQuery } from 'auth/hooks'
import ms from 'ms'

export const userQueryOptions = {
  placeholderData: keepPreviousData,
  staleTime: ms('15s'),
}

export function useIsTrialUserQuery(options?: { enabled?: boolean }) {
  return useUserQuery(undefined, {
    ...userQueryOptions,
    enabled: options?.enabled,
    select(data) {
      const subscription = data.me?.user?.subscriptionAccess?.studioAi
      return Boolean(subscription?.isSubscribed && subscription.subscription?.isTrial)
    },
  })
}
